import { ApolloLink } from '@apollo/client';
import {
  ArgumentNode,
  DocumentNode,
  FieldNode,
  Kind,
  OperationDefinitionNode,
} from 'graphql';

const DISPATCH_ARGUMENT = 'functionName';

const dispatchName = (field: FieldNode): string | null => {
  const argument = field.arguments?.find(
    (candidate: ArgumentNode) => candidate.name.value === DISPATCH_ARGUMENT,
  );
  return argument?.value.kind === Kind.STRING ? argument.value.value : null;
};

export const mutationOperationKeys = (query: DocumentNode): string[] => {
  const mutations = query.definitions.filter(
    (definition): definition is OperationDefinitionNode =>
      definition.kind === Kind.OPERATION_DEFINITION &&
      definition.operation === 'mutation',
  );
  return mutations.flatMap(definition =>
    definition.selectionSet.selections
      .filter(
        (selection): selection is FieldNode => selection.kind === Kind.FIELD,
      )
      .map(field => {
        const dispatch = dispatchName(field);
        return dispatch ? `${field.name.value}:${dispatch}` : field.name.value;
      }),
  );
};

export const createBackendWriteLink = (
  onBackendWrite: (operation: string) => void,
): ApolloLink =>
  new ApolloLink((operation, forward) => {
    const [write] = mutationOperationKeys(operation.query);
    if (write) {
      onBackendWrite(write);
    }
    return forward(operation);
  });
